import React from 'react';

import type { SweetpassUpgradeScreenPalette } from './SweetgreenUpgradeScreenPalette';
import { SweetpassUpgradeBenefitListContent } from './SweetpassUpgradeBenefitListContent';
import { SweetpassUpgradeHeaderContent } from './SweetpassUpgradeHeaderContent';
import type {
  SweetpassUpgradeBenefitList,
  SweetpassUpgradeContent,
  SweetpassUpgradeCtaHandler,
  SweetpassUpgradeHeader,
} from './SweetpassUpgradeScreen.loaded';

type SweetpassUpgradeInnerContentProps = {
  readonly content: SweetpassUpgradeContent;
  readonly palette: SweetpassUpgradeScreenPalette;
  readonly ctaHandler: SweetpassUpgradeCtaHandler;
};

export const SweetpassUpgradeInnerContent = ({
  content,
  palette,
  ctaHandler,
}: SweetpassUpgradeInnerContentProps) => {
  if (content.type === 'sweetpassUpgradeHeader') {
    const headerContent = content as SweetpassUpgradeHeader;

    return (
      <SweetpassUpgradeHeaderContent
        content={headerContent}
        palette={palette.header}
        ctaHandler={ctaHandler}
      />
    );
  }

  if (content.type === 'sweetpassUpgradeBenefitList') {
    const benefitListContent = content as SweetpassUpgradeBenefitList;

    return (
      <SweetpassUpgradeBenefitListContent
        content={benefitListContent}
        palette={palette.benefitList}
      />
    );
  }

  return null;
};
